import React from 'react';
import { Button, Col, Row, Card } from 'react-bootstrap';
import DetailsFournisseur from './formulaireComponents/detailsFournisseur';
import DetailsDocumant from './formulaireComponents/detailsDocumant';
import DetailsProduit from './formulaireComponents/detailsProduitsAchat';
import ProduitModal from 'components/pages/fiches/produitsServices/ajoutWizard/ajoutProduitModal';
import RecapAchat from './formulaireComponents/recapAchat';
import { LuSave } from 'react-icons/lu';
import { toast } from 'react-toastify';
import { saveAchat } from 'data/achats';
import { useNavigate, useParams } from 'react-router-dom';

const AchatFormulaire = () => {
  const [showExtra, setShowExtra] = React.useState(true);
  const [modalShow, setModalShow] = React.useState(false);
  const [TotalPrixHT, setTotalPrixHT] = React.useState(0.0);
  const [recapTva, setRecapTva] = React.useState([]);
  const [produits, setProduitsAchat] = React.useState([]);
  const [fournisseur, setFournisseur] = React.useState({});
  const [document, setDocument] = React.useState({
    dateDocument: new Date(),
    dateLivraison: new Date()
  });
  const { formulaireAchat } = useParams();
  const navigate = useNavigate();

  const typeOperation =
    formulaireAchat === 'nouvelAchat' ? 'nouveau' : 'modification';

  const handleSubmit = async () => {
    console.log('produits :', produits);
    if (Object.keys(fournisseur).length === 0) {
      toast.error('Veuillez choisir un fournisseur!', {
        theme: 'colored',
        position: 'top-right'
      });
      return;
    }

    if (produits.length === 0) {
      toast.error('Veuillez ajouter au moins un produit!', {
        theme: 'colored',
        position: 'top-right'
      });
      return;
    }

    console.log('entete :');
    console.log({ ...fournisseur, ...document, tva: { ...recapTva } });

    console.log('lignes :');
    console.log(produits);
    const response = await saveAchat({
      entete: { ...fournisseur, ...document, tva: { ...recapTva } },
      lignes: produits
    });
    console.log(response);
    if (response.status !== 200) {
      toast.error("Un erreur s'est avéré!", {
        theme: 'colored',
        position: 'top-right'
      });
      return;
    }

    toast.success('Enregistrement effectué avec succès!', {
      theme: 'colored',
      position: 'top-right'
    });
    navigate('/dashboard/achat');
  };

  return (
    <>
      <ProduitModal modalShow={modalShow} setModalShow={setModalShow} />

      <Card style={{ height: '80px' }} className="">
        <div className="d-flex justify-content-between align-items-center h-100 px-3">
          <div className="d-flex align-items-center gap-3">
            <h3 className="mb-0"> {'Achat'}</h3>
            <Button
              variant="falcon-primary"
              className="d-flex align-items-center gap-2"
              onClick={handleSubmit}
            >
              {' '}
              <LuSave />
              {typeOperation === 'nouveau' ? 'Enregistrer' : 'Modifier'}
            </Button>
          </div>
          <Button onClick={() => setShowExtra(!showExtra)}>
            afficher/Masquer
          </Button>{' '}
        </div>
      </Card>

      <Row className="mt-4">
        <Col>
          <DetailsProduit
            setModalShow={setModalShow}
            setTotalPrixHT={setTotalPrixHT}
            setRecapTva={setRecapTva}
            setProduitsAchat={setProduitsAchat}
          />
        </Col>
        {showExtra && (
          <Col md={4} style={{ position: 'sticky', top: '0' }}>
            <DetailsFournisseur
              setFournisseur={setFournisseur}
              fournisseur={fournisseur}
            />
            <DetailsDocumant setDocument={setDocument} document={document} />
          </Col>
        )}
      </Row>
      <Row className="mt-4">
        <Col md={{ span: 4, offset: 8 }}>
          <RecapAchat TotalPrixHT={TotalPrixHT} recapTva={recapTva} />
        </Col>
      </Row>
    </>
  );
};

export default AchatFormulaire;
